import { useNavigate } from 'react-router-dom';

const ShopSection = () => {
  const navigate = useNavigate();

  const products = [
    {
      name: 'MOUMITU シャンプー',
      price: '¥8,800',
      description: '頭皮環境を整える高濃度成長因子配合',
      image: 'https://public.readdy.ai/ai/img_res/0be562c314d4045671f2201d182f3783.jpg',
    },
    {
      name: 'Revcella 美容液',
      price: '¥12,000',
      description: 'プラズマ施術後のホームケアに最適',
      image: 'https://readdy.ai/api/search-image?query=Premium%20facial%20serum%20bottle%2C%20elegant%20white%20and%20gold%20packaging%2C%20luxury%20skincare%20product%2C%20simple%20white%20background%2C%20high-end%20beauty%20essence%2C%20professional%20grade%20cosmetic%2C%20minimalist%20design%2C%20clean%20product%20shot&width=600&height=600&seq=product-serum-001&orientation=squarish',
    },
    {
      name: 'ボディメイクサポートサプリ',
      price: '¥6,500',
      description: '施術効果を高める栄養サポート',
      image: 'https://readdy.ai/api/search-image?query=Premium%20supplement%20bottle%2C%20elegant%20white%20and%20gold%20packaging%2C%20luxury%20wellness%20product%2C%20simple%20white%20background%2C%20high-end%20nutritional%20supplement%2C%20professional%20beauty%20supplement%2C%20minimalist%20design%2C%20clean%20product%20photography&width=600&height=600&seq=product-supplement-001&orientation=squarish',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-dark-gray mb-3">
            サロン品質をご自宅でも
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto"></div>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
          {products.map((product, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-64 bg-beige rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
              onClick={() => navigate('/shop')}
            >
              <div className="aspect-square bg-white rounded-xl m-4 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-semibold text-dark-gray mb-2 text-base">
                  {product.name}
                </h3>
                <p className="text-2xl font-montserrat font-semibold text-gold mb-2">
                  {product.price}
                </p>
                <p className="text-xs text-medium-gray leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/shop')}
            className="bg-gold text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-gold/90 transition-colors shadow-md hover:shadow-lg w-full md:w-auto whitespace-nowrap"
          >
            オンラインショップへ
          </button>
        </div>
      </div>
    </section>
  );
};

export default ShopSection;
